import { AxiosRequestHeaders } from 'axios';
import { capability } from '../rpc-client/config/capabilities';
import RpcClientFactory from '../rpc-client/factory/rpc-client-factory';
import { DtoTypes } from '../index';

export async function getPolicyBillingSummary(
    policyNumber: string,
    headers: AxiosRequestHeaders = {}
): Promise<DtoTypes.BC.edge.capabilities.billing.dto.PolicyBillingSummaryDTO> {
    return await RpcClientFactory.getInstance().rpcCall<DtoTypes.BC.edge.capabilities.billing.dto.PolicyBillingSummaryDTO>(
        capability.BC_BILLING_DATA,
        'getPolicyBillingSummary',
        [policyNumber],
        headers
    );
}

export async function getAllPaymentPlans_Top(
    headers: AxiosRequestHeaders = {}
): Promise<DtoTypes.BC.edge.capabilities.billing.dto.PaymentPlanDTO> {
    return await RpcClientFactory.getInstance().rpcCall<DtoTypes.BC.edge.capabilities.billing.dto.PaymentPlanDTO>(
        capability.BC_BILLING_DATA,
        'getAllPaymentPlans_Top',
        [],
        headers
    );
}
